import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import useVerifiedOnMobileInstructions from '../Utils/useVerifiedOnMobileInstructions';
import ContentLink from './ContentLink';
import InstructionsSpanTypography from './InstructionsSpanTypography';

function VerifiedOnMobileInstructions(): React.JSX.Element {
    const { proceedToProductHandler } = useVerifiedOnMobileInstructions();
    return (
        <div className="text-sm leading-relaxed">
            <InstructionsSpanTypography>{`${UIStrings.IfIHaveAlreadyVerifiedOnMyMobileDevice} `}</InstructionsSpanTypography>
            <ContentLink onClick={proceedToProductHandler}>{UIStrings.ClickHereToProceed}</ContentLink>
            <InstructionsSpanTypography>{` ${UIStrings.ToTalentmesh}`}</InstructionsSpanTypography>
        </div>
    );
}

export default VerifiedOnMobileInstructions;
